import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Film, Users, Ticket, User } from 'lucide-react';

export default function BottomNav() {
  const location = useLocation();

  // Hide BottomNav on details page, seat allocation, and cart
  const isHiddenPage = /^\/shows\/\d+/.test(location.pathname) || location.pathname.startsWith('/cart');
  if (isHiddenPage) return null;


  const navItems = [
    { name: 'Home', path: '/', icon: <Home size={20} /> },
    { name: 'Shows', path: '/shows', icon: <Film size={20} /> },
    { name: 'Gananatya', path: '/gananatya', icon: <Users size={20} /> },
    { name: 'My Tickets', path: '/my-tickets', icon: <Ticket size={20} /> },
    { name: 'Profile', path: '/profile', icon: <User size={20} /> },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-[#1c1c1c] rounded-t-2xl z-[60] pb-safe shadow-[0_-4px_20px_rgba(0,0,0,0.5)]">
      <div className="flex justify-around items-center h-20 px-2 pb-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <Link 
              key={item.name} 
              to={item.path}
              className="flex flex-col items-center justify-center w-16"
            >
              <div className={`flex flex-col items-center justify-center w-full py-1.5 transition-all duration-200 rounded-2xl ${isActive ? 'bg-[#3d1919] text-[#ff4040]' : 'text-gray-400'}`}>
                <div className="mb-1">{item.icon}</div>
                <span className="text-[10px] font-medium tracking-wide">{item.name}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
